import { createSelectorCreator, defaultMemoize } from 'reselect'
import { shallowEqual } from 'tangle-shared'

export const createShallowEqualSelector = createSelectorCreator(
  defaultMemoize,
  shallowEqual
)
